export default "__VITE_ASSET__RrU_ViWoYsKLextjJEd0Tg__"